import data from 'react-intl/locale-data/en';
import locale from 'antd/lib/locale-provider/en_US';
import { messages } from 'lngProvider/locales/en_US.js';

export default { locale: 'en-US', antd: locale, messages, data };
